import { Component, OnInit } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
// import {Auth} from 'aws-amplify';
import { signInWithRedirect, signOut } from 'aws-amplify/auth';
import {environment} from '@environments/environment';
import {ActivatedRoute} from '@angular/router';
import {PasswordService} from '@shared/services/password.service';

@Component({
    selector: 'app-password-expiry',
    templateUrl: './password-expiry.component.html',
    styleUrls: ['./password-expiry.component.scss'],
    standalone: false
})
export class PasswordExpiryComponent implements OnInit {

  isFormValid: boolean = false;
  passwordMatch: boolean = false;
  showConfirmModal: boolean = false;
  form: UntypedFormGroup;

  showPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  showSuccessModal: boolean = false;
  showFailModal: boolean = false;
  // tslint:disable-next-line:max-line-length
  passwordPattern = `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*()\\-_+=])[A-Za-z\\d!@#$%^&*()\\-_+=]{9,}$`

  pattern_UpperCase: RegExp = new RegExp('[A-Z]+');
  pattern_LowerCase: RegExp = new RegExp('[a-z]+');
  pattern_Special: RegExp = new RegExp('[!@#$%^&*()\\-_+=]+');
  pattern_Number: RegExp = new RegExp('[0-9]+');
  pattern_Repetition: RegExp = new RegExp('(.)\\1+');

  modalMessage: string = '';
  modalTitle: string = '';
  token: string;
  email: string;
  isLoading: boolean = false;

  constructor(private fb: UntypedFormBuilder,
              private route: ActivatedRoute,
              private pass: PasswordService) {
      this.token = this.route.snapshot.queryParamMap.get('token');
      this.email = this.route.snapshot.queryParamMap.get('email');


  }

  ngOnInit() {
    this.initForm();
    this.form.controls['email'].setValue(this.email);
  }

  initForm() {
    this.form = this.fb.group({
      currentPassword: ['' , [ Validators.required,
        Validators.min(8)]],
      newPassword: ['' , [Validators.required,
        Validators.min(9),
        Validators.pattern(this.passwordPattern)]],
      confirmPassword: ['' , [Validators.required,
        Validators.min(9),
        Validators.pattern(this.passwordPattern)]],
      email: ['' , [Validators.required]]
    });

    this.form.valueChanges.subscribe(
        data => { this.validateForm(); }
    )
  }

  validateForm() {
      this.passwordMatch = this.form.controls['newPassword'].value === this.form.controls['confirmPassword'].value;
      this.isFormValid = (this.form.valid && this.passwordMatch ) &&
          (!this.hasRepetition(this.form.controls['newPassword'].value)) &&
          (this.email.localeCompare(this.form.controls['newPassword'].value) !== 0 );
  }
  hasRepetition(val: string) {
        return this.pattern_Repetition.test(val)
  }

  onSave() {
    this.showConfirmModal = false;
    const email = this.email;
    const token = this.token;
    const pass = this.form.controls['currentPassword'].value;
    const newPass = this.form.controls['newPassword'].value;
    this.isLoading = true;
    this.validate(email, pass, newPass, token);
  }

  validate(email: string,
           pass: string,
           newPass: string,
           token: string) {
    this.pass
        .validateExpiredPass(email, newPass, token)
        .subscribe({
          next: (data) => {
            const res = data['body'];
            if (res['is_valid'] === true ) {
              this.changePass(email, pass, newPass, token);
              return;
            }
            if (res['is_valid'] === false ) {
              this.onFail('Cannot reuse last 5 passwords.\nPlease choose another Password ', 'Error');
              this.isLoading = false;
              return;
            }
            this.isLoading = false;
            this.onFail(res, 'Error');
          },
          error: (error) => {
            console.log(error);
            this.isLoading = false;
            if (error.error === 'Invalid Token') {
                this.onFail('Update Password link expires after 15 minutes.\nPlease retry logging in.',   'Update Password Expired');
            } else if (error.error === 'Invalid username/password') {
                this.onFail('Invalid previous password', 'Error');
            } else {
                this.onFail(error.error, 'Error');
            }
          },
        })
  }

  changePass(email: string,
             pass: string,
             newPass: string,
             token: string) {
    this.pass
        .changExpiredPassword(email, pass, newPass, token)
        .subscribe({
          next: (data) => {
            this.isLoading = false;
            if (data['status'] !== 200) {
              return;
            }
            const res = data['body']
            if ( res['Status'] === 'Password successfully changed' ) {
              this.onSuccess();
            } else if (res['Status'] === 'Invalid username/password') {
                this.onFail('Invalid previous password', 'Error');
            } else  {
              this.onFail(res['Status'], 'Error');
            }
            console.log(data);
          },
          error: (error) => {
            this.isLoading = false;
            this.onFail(error.error, 'Error');
            console.log(error)
          }
        })
  }
  onFail(message: string, title: string) {
      this.modalMessage = message;
      this.modalTitle = title;
      this.showFailModal = true;
  }
  onSuccess() {
    this.showSuccessModal = true;
  }
  async logout() {
    // Auth.signOut();
    await signOut();
    localStorage.clear();
    // window.location.replace(environment.signOut);
  }


}
